/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Weather_Row_WeatherInputs */

const en_ui_weather_row_weather = /** @type {(inputs: Ui_Weather_Row_WeatherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weather`)
};

const de_ui_weather_row_weather = /** @type {(inputs: Ui_Weather_Row_WeatherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wetter`)
};

/**
* | output |
* | --- |
* | "Weather" |
*
* @param {Ui_Weather_Row_WeatherInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_weather_row_weather = /** @type {((inputs?: Ui_Weather_Row_WeatherInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Weather_Row_WeatherInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_weather_row_weather(inputs)
	return de_ui_weather_row_weather(inputs)
});